import { memo } from 'react';

import { SvgIcon } from '@material-ui/core';

import { SvgIconProps } from './SvgIcon.types';

export const FolderPaperclipIcon = memo(({ className }: SvgIconProps) => (
  <SvgIcon
    className={className}
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ fill: 'none' }}
  >
    <path
      d="M32.1461 16.6268C31.8164 16.2312 31.3549 16.0334 30.8933 16.0334H27.7286V4.23145C27.7286 3.30839 27.0033 2.58313 26.0802 2.58313H9.39922C8.47616 2.58313 7.7509 3.30839 7.7509 4.23145V12.2093H4.52019C3.99273 12.2093 3.5312 12.4071 3.26746 12.8027C2.9378 13.1983 2.80593 13.6599 2.9378 14.1873L6.23444 30.8683C6.36631 31.6595 7.09157 32.187 7.88276 32.187H28.322C29.1131 32.187 29.7725 31.6595 29.9703 30.8683C30.4977 28.231 31.8823 21.1762 32.5417 18.0114C32.5417 17.5499 32.4098 17.0224 32.1461 16.6268Z"
      fill="#F0CBA7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.95968 1.61066C6.51368 1.61066 6.11904 1.96763 6.11904 2.4513V2.45457H6.11902L6.05309 10.7621C6.05128 10.9897 5.86533 11.1727 5.63775 11.1709C5.41017 11.1691 5.22715 10.9832 5.22896 10.7556L5.29488 2.44956C5.29583 1.48362 6.08755 0.786499 6.95968 0.786499H23.5748C24.5416 0.786499 25.2396 1.57864 25.2396 2.4513V14.6489C25.2396 14.8765 25.0551 15.061 24.8275 15.061C24.5999 15.061 24.4154 14.8765 24.4154 14.6489V2.4513C24.4154 2.00531 24.0584 1.61066 23.5748 1.61066H6.95968Z"
      fill="#226937"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.8552 12.6709C14.8552 12.4433 15.0397 12.2588 15.2673 12.2588H20.0804C20.308 12.2588 20.4925 12.4433 20.4925 12.6709C20.4925 12.8985 20.308 13.083 20.0804 13.083H15.2673C15.0397 13.083 14.8552 12.8985 14.8552 12.6709Z"
      fill="#226937"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.866246 10.929C1.17489 10.6203 1.60319 10.3467 2.14662 10.3467H10.3882C11.1946 10.3467 11.8731 10.9622 12.0429 11.7227C12.043 11.7232 12.0431 11.7238 12.0432 11.7244L12.4388 13.4386C12.5334 13.8641 12.9094 14.1708 13.2893 14.1708H28.4538C28.9223 14.1708 29.422 14.435 29.7507 14.8358C30.1285 15.2271 30.1902 15.77 30.113 16.2331C30.112 16.2391 30.1109 16.2451 30.1096 16.2511C29.6099 18.5996 28.693 23.2239 28.0489 26.4724C27.844 27.5057 27.6667 28.3997 27.5393 29.0371L27.5375 29.0457C27.3684 29.807 26.6894 30.4233 25.8825 30.4233H5.44327C4.63633 30.4233 3.95745 29.807 3.78828 29.0457L3.78628 29.0362L0.489638 12.3552L0.487426 12.343C0.409146 11.8733 0.473784 11.3214 0.866246 10.929ZM2.14662 11.1709C1.89886 11.1709 1.66783 11.2929 1.44902 11.5117C1.31482 11.6459 1.24759 11.8832 1.29943 12.2018L4.59378 28.8712C4.68991 29.2945 5.06469 29.5991 5.44327 29.5991H25.8825C26.2612 29.5991 26.6361 29.2943 26.732 28.8708C26.8588 28.2369 27.0351 27.3478 27.2389 26.3198C27.8823 23.0754 28.8 18.4471 29.3015 16.0891C29.3525 15.7718 29.2853 15.5356 29.1514 15.4018C29.1407 15.391 29.1306 15.3797 29.121 15.3678C28.9219 15.1189 28.6381 14.995 28.4538 14.995H13.2893C12.4829 14.995 11.8044 14.3796 11.6347 13.6191C11.6345 13.6185 11.6344 13.6179 11.6343 13.6174L11.2387 11.9031C11.1441 11.4776 10.7681 11.1709 10.3882 11.1709H2.14662Z"
      fill="#EA7200"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.11902 4.95676C9.11902 4.72917 9.30351 4.54468 9.5311 4.54468H20.0804C20.3079 4.54468 20.4924 4.72917 20.4924 4.95676C20.4924 5.18434 20.3079 5.36884 20.0804 5.36884H9.5311C9.30351 5.36884 9.11902 5.18434 9.11902 4.95676Z"
      fill="#226937"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.1409 8.84677C13.1409 8.61919 13.3254 8.43469 13.553 8.43469H20.0804C20.308 8.43469 20.4924 8.61919 20.4924 8.84677C20.4924 9.07436 20.308 9.25885 20.0804 9.25885H13.553C13.3254 9.25885 13.1409 9.07436 13.1409 8.84677Z"
      fill="#226937"
    />
  </SvgIcon>
));
